export {
  DEFAULT_COORDS,
  formatDistance,
  calculateDistanceKm,
  isLocationOpen,
  getBusinessHoursText,
} from '~/mixins/scheduleEvaluation/config'

// Web 端地图初始视野：覆盖整个旧金山湾区（南至 San Jose，北至 Berkeley/Oakland）
// touch 端共用 mixin 默认值，这里仅 web 端覆盖
export const MAP_DEFAULT_CENTER = { lat: 37.6, lng: -122.1 }
export const MAP_DEFAULT_ZOOM = 9
